<template>
    <div class="divider">
        <label class="contentLabel" for="fontSize">{{ $t('Add.General.FontSize') }}</label>
        <div class="range-container">
        <input type="range" min="1" max="40" v-model="fontSize" class="slider" id="fontSize" />
        <span v-if="!sharedData?.data?.style?.fontSize || sharedData?.data?.style?.fontSize == emailData.root.data.fontSize " style="color: var(--primary-color)">
        {{ fontSize }} px
        </span>
        <span v-else>{{ fontSize }} px</span>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    props: ['sharedData'],
    computed:{
    ...mapState(['emailData']),
    fontSize: {
      get() {
        return this.sharedData?.data?.style?.fontSize || 16;
      },
      set(value) {
        if (!this.sharedData.data.style) {
          this.sharedData.data.style = {};
        }
        this.sharedData.data.style.fontSize = value;
      },
    },
    },

}
</script>

<style>
 @import '../../../styles/addComponents.css';
</style>